// extracted by mini-css-extract-plugin
export default {"t":"style_t__SnhN7","s":"style_s__s89cF","s2":"style_s2__OWAAp"};